import { Page, Spin, Text, Title } from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import Instructions from './Instructions';
import RosterEditor from './RosterEditor';
import RosterFinder from './RosterFinder';
import RosterDataViewerPageContext from './RosterDataViewerPageContext';

const RosterDataViewerPageContent: React.FC = () => {
  const { boards } = useContext(RosterDataViewerPageContext);

  if (!boards.length) return <Spin size="large" center />;

  return (
    <Page type="filled" fillScreenHeight>
      <Layout>
        <Title level={1} hideMargin data-cy="page-title">
          Roster Data Viewer QA Page
        </Title>
        <Text>
          This QA page is used to view and update individual roster entries
        </Text>

        <Instructions />
        <RosterFinder />
        <RosterEditor />
      </Layout>
    </Page>
  );
};

export default RosterDataViewerPageContent;

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 32px;
  padding: 20px;
  background: white;
`;
